class SizeGuide3dids extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.querySelector('[data-size-guide-open]')?.addEventListener('click', () => this.dialog?.showModal());
    this.querySelectorAll('[data-size-guide-close]').forEach((button) => button.addEventListener('click', () => this.dialog?.close()));
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
  }
}

if (!customElements.get('size-guide-3dids')) {
  customElements.define('size-guide-3dids', SizeGuide3dids);
}
